import { Deserializable } from './deserializable';
import { BaseModel } from './baseModel';


export class NewUserRequestResult extends BaseModel implements Deserializable {

  accepted: boolean;

  acceptRejectNotes: string;

  startDate: string;
  expirationDate: string;

  startDateDate: Date;
  expirationDateDate: Date;

  deserialize(input: any) {

    super.deserialize(input);
    Object.assign(this, input);

    this.startDateDate = new Date(this.startDate);
    this.expirationDateDate = new Date(this.expirationDate);

    return this;
  }
}
